import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=22c88bc4&scoped=true"
import script from "./Acciones.vue?vue&type=script&lang=js"
export * from "./Acciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c88bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c88bc4')) {
      api.createRecord('22c88bc4', component.options)
    } else {
      api.reload('22c88bc4', component.options)
    }
    module.hot.accept("./Acciones.vue?vue&type=template&id=22c88bc4&scoped=true", function () {
      api.rerender('22c88bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibo/Acciones.vue"
export default component.exports